// PGCET MCA Mock 6 — Mathematics (questions 1–30)
const pgcetmcaMathematics = [
  {
    id: 1,
    question: "The value of the determinant of A = [[2, 1, 3], [0, 4, 5], [1, 0, 6]] is",
    options: ["A. 37", "B. 41", "C. 45", "D. 29"],
    answer: "B"
  },
  {
    id: 2,
    question: "If A = [[3, 2], [1, 4]], then A² is",
    options: ["A. [[11, 14], [7, 18]]", "B. [[9, 4], [1, 16]]", "C. [[11, 10], [7, 18]]", "D. [[13, 14], [7, 16]]"],
    answer: "A"
  },
  {
    id: 3,
    question: "The value of k for which the matrix [[k, 2], [6, 3]] is singular is",
    options: ["A. 2", "B. 3", "C. 6", "D. 4"],
    answer: "D"
  },
  {
    id: 4,
    question: "If A is a square matrix of order 3 with |A| = 5, then |3A| equals",
    options: ["A. 15", "B. 45", "C. 135", "D. 125"],
    answer: "C"
  },
  {
    id: 5,
    question: "The inverse of the matrix [[2, 5], [1, 3]] is",
    options: ["A. [[3, 5], [1, 2]]", "B. [[−3, 5], [1, −2]]", "C. [[2, −5], [−1, 3]]", "D. [[3, −5], [−1, 2]]"],
    answer: "D"
  },
  {
    id: 6,
    question: "The system of equations x + 2y = 3 and 3x + ky = 5 has no solution when k equals",
    options: ["A. 6", "B. 2", "C. 3", "D. −6"],
    answer: "A"
  },
  {
    id: 7,
    question: "The value of the determinant [[1, 1, 1], [a, b, c], [a³, b³, c³]] is",
    options: ["A. abc(a − b)(b − c)(c − a)", "B. (a + b + c)", "C. (a − b)(b − c)(c − a)(a + b + c)", "D. 0"],
    answer: "C"
  },
  {
    id: 8,
    question: "Three unbiased coins are tossed together. The probability of getting at least two heads is",
    options: ["A. 3/8", "B. 1/2", "C. 1/4", "D. 7/8"],
    answer: "B"
  },
  {
    id: 9,
    question: "Two dice are thrown together. The probability that the sum of the numbers on them is 9 is",
    options: ["A. 1/9", "B. 1/12", "C. 1/6", "D. 5/36"],
    answer: "A"
  },
  {
    id: 10,
    question: "A and B are independent events with P(A) = 0.4 and P(B) = 0.5. Then P(A ∪ B) is",
    options: ["A. 0.9", "B. 0.2", "C. 0.7", "D. 0.6"],
    answer: "C"
  },
  {
    id: 11,
    question: "A card is drawn at random from a well-shuffled pack of 52 cards. The probability that it is either a heart or a king is",
    options: ["A. 17/52", "B. 4/13", "C. 1/4", "D. 1/13"],
    answer: "B"
  },
  {
    id: 12,
    question: "A bag contains 4 red and 6 white balls. Three balls are drawn at random without replacement. The probability that all three are white is",
    options: ["A. 1/5", "B. 27/125", "C. 1/10", "D. 1/6"],
    answer: "D"
  },
  {
    id: 13,
    question: "A fair coin is tossed 4 times. The probability of getting exactly 2 heads is",
    options: ["A. 1/4", "B. 1/2", "C. 5/16", "D. 3/8"],
    answer: "D"
  },
  {
    id: 14,
    question: "For a Poisson random variable X, P(X = 1) = P(X = 2). The mean of the distribution is",
    options: ["A. 1", "B. 2", "C. 4", "D. 1/2"],
    answer: "B"
  },
  {
    id: 15,
    question: "The eccentricity of the hyperbola x²/16 − y²/9 = 1 is",
    options: ["A. 5/4", "B. 4/5", "C. 5/3", "D. 3/4"],
    answer: "A"
  },
  {
    id: 16,
    question: "The length of the latus rectum of the parabola y² = 12x is",
    options: ["A. 3", "B. 6", "C. 12", "D. 24"],
    answer: "C"
  },
  {
    id: 17,
    question: "The foci of the ellipse x²/25 + y²/16 = 1 are",
    options: ["A. (±4, 0)", "B. (0, ±3)", "C. (±5, 0)", "D. (±3, 0)"],
    answer: "D"
  },
  {
    id: 18,
    question: "The equation of the directrix of the parabola x² = −16y is",
    options: ["A. y = −4", "B. y = 4", "C. x = 4", "D. x = −4"],
    answer: "B"
  },
  {
    id: 19,
    question: "The length of the latus rectum of the ellipse 4x² + 9y² = 36 is",
    options: ["A. 4/3", "B. 9/2", "C. 16/3", "D. 8/3"],
    answer: "D"
  },
  {
    id: 20,
    question: "The eccentricity of the hyperbola x² − y² = 9 is",
    options: ["A. 1", "B. 3", "C. √2", "D. 2"],
    answer: "C"
  },
  {
    id: 21,
    question: "The value of the integral ∫ x eˣ dx from 0 to 1 is",
    options: ["A. e", "B. 1", "C. e − 1", "D. e − 2"],
    answer: "B"
  },
  {
    id: 22,
    question: "The value of the integral ∫ sin x / (sin x + cos x) dx from 0 to π/2 is",
    options: ["A. π/2", "B. π", "C. π/4", "D. 0"],
    answer: "C"
  },
  {
    id: 23,
    question: "The value of the integral ∫ |x| dx from −2 to 2 is",
    options: ["A. 0", "B. 2", "C. 8", "D. 4"],
    answer: "D"
  },
  {
    id: 24,
    question: "The value of the integral ∫ tan²x dx from 0 to π/4 is",
    options: ["A. 1 − π/4", "B. π/4", "C. 1 + π/4", "D. π/4 − 1"],
    answer: "A"
  },
  {
    id: 25,
    question: "The value of the integral ∫ x(1 − x)⁵ dx from 0 to 1 is",
    options: ["A. 1/30", "B. 1/42", "C. 1/56", "D. 1/35"],
    answer: "B"
  },
  {
    id: 26,
    question: "The angle between the vectors a = i + j and b = j + k is",
    options: ["A. π/6", "B. π/4", "C. π/3", "D. π/2"],
    answer: "C"
  },
  {
    id: 27,
    question: "The area of the parallelogram whose adjacent sides are a = i + 2j + 2k and b = 2i + j − 2k is",
    options: ["A. 9", "B. 81", "C. 3", "D. 9/2"],
    answer: "A"
  },
  {
    id: 28,
    question: "The scalar projection of the vector a = i + 2j + 3k on the vector b = 2i − j + 2k is",
    options: ["A. 6/√14", "B. 6", "C. 3", "D. 2"],
    answer: "D"
  },
  {
    id: 29,
    question: "The value of m for which the vectors 2i + mj + k and i − 2j + 3k are perpendicular is",
    options: ["A. 5/2", "B. −5/2", "C. 2/5", "D. 3/2"],
    answer: "A"
  },
  {
    id: 30,
    question: "The scalar triple product [i + j, j + k, k + i] equals",
    options: ["A. 0", "B. 1", "C. 3", "D. 2"],
    answer: "D"
  }
];

export default pgcetmcaMathematics;
